export default "__VITE_PUBLIC_ASSET__0331e89b__"